import type { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { client } from '../common';

type Variables = { id: number };
export type CarTutorialResponse = {
  instructions: [
    {
      id: number;
      image: string;
      instruction: string;
      title: string;
      video: string;
    }
  ];

  questions: [
    {
      correct_answers: string[];
      id: string;
      options: [{ id: string; value: string }];
      question: string;
    }
  ];
};

export const useCarTutorial = createQuery<
  CarTutorialResponse,
  Variables,
  AxiosError
>({
  queryKey: ['cars/id/tutorial'],
  fetcher: ({ id }) => {
    return client.get(`v2/cars/${id}/tutorial`).then((response) => {
      return response.data.data;
    });
  },
});
